import React from 'react';
import { Itemset, ItemsetResult } from "../../../store/viewmodels/ItemsetViewModel";
import { Item } from "../../../store/viewmodels/ItemViewModel";
import { Task } from "../../../store/viewmodels/TaskViewModel";
import { AnswerSet } from '../../../store/viewmodels/AnswerSetViewModel';
import { getNextUrl, postCheck } from "../../../utils/TaskNavigationServices";
import { getElementsByFiles } from "../../../utils/TaskContentServices";
import { StudentData } from '../../../store/viewmodels/StudentViewModel';
import { setEndTime, postAnswerSet, resetAsSliceState, addItemSet, addStudentId, setStartTime, addAnswerToSet } from "../../../store/AnswerSetSlice";
import { useAppDispatch } from "../../../store/Hooks";
import { useAppSelector } from "../../../store/Hooks";
import { useHistory } from "react-router-dom";
import { Answer } from '../../../store/viewmodels/AnswerViewModel';
import Header from './Header';


interface StudentVideoInstructionItemProps {
    task: Task,
    itemset: Itemset,
    item: Item
}

function StudentVideoInstructionItem(props: StudentVideoInstructionItemProps) {
    const dispatch = useAppDispatch();
    const studentData: StudentData = useAppSelector(state => state.studentData);
    let aStartTime = new Date();
    const history = useHistory();
    const asData: AnswerSet = useAppSelector(state => state.answerSet);
    const [postAs, setPostAs] = React.useState(false);

    const nextUrl = getNextUrl(props.itemset, props.item, props.task, studentData.student.active_item_sets);
    if (nextUrl === `/student/tasks/` && !postAs && asData.answers.length > 0) { setPostAs(true); }

    React.useEffect(() => {
        const itemset: ItemsetResult = { id: props.itemset.id, name: props.itemset.name, type: props.itemset.type }
        dispatch(addStudentId(studentData.student.id));
        dispatch(addItemSet(itemset));
        let asStartTime = new Date();
        dispatch(setStartTime(asStartTime.toISOString()));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const commitAnswer = () => {
        history.push(nextUrl.toString());
        let answer: Answer = {} as Answer;
        let aEndTime = new Date();
        answer.item = props.item.id;
        answer.value = "";
        answer.end_time = aEndTime.toISOString();
        answer.start_time = aStartTime.toISOString();
        dispatch(addAnswerToSet(answer));

        const postAnswerSetCheck: boolean = postCheck(props.itemset, props.item, props.task, studentData.student.active_item_sets);
        if (postAnswerSetCheck) {
            let asEndTime = new Date();
            dispatch(setEndTime(asEndTime.toISOString()));
            dispatch(postAnswerSet())
                .then(() => {
                    dispatch(resetAsSliceState());
                })
        }
    }

    let instructionElement: JSX.Element = <div></div>;
    let files = getElementsByFiles(props.item);

    let elements: JSX.Element[] = [];

    if (props.item.files?.length === 1) {
        let element = (
            <div key={"instructionFileElement_" + props.item.id + "_0"} className="flex max-h-full max-w-full mx-2 p-2">
                <div className={"bg-teal-500 flex m-auto max-w-full overflow-hidden rounded-2xl shadow ring-teal-500 ring-4 lg:ring-8 bg-teal-500 "}>
                    {files[0]}
                </div>
            </div>);

        elements.push(element);

    } else {
        for (let i: number = 0; i < props.item.files?.length; i++) {
            let margin = (i === 2 ) ? "mr-0 ml-auto" : "m-auto";
            let element = (
                <div key={"instructionFileElement_" + props.item.id + "_" + i} className="flex max-h-full max-w-full mx-2 p-2">
                    <div className={"bg-teal-500 flex my-auto max-w-full overflow-hidden rounded-2xl shadow ring-teal-500 ring-4 lg:ring-8 bg-teal-500 " + margin}>
                        {files[i]}
                    </div>
                </div>);

            elements.push(element);
        }
    }

    let gridCols = "";
    let maxW = " max-w-full ";

    switch (files.length) {
        case 1: {
            gridCols = " grid-cols-1 ";
            maxW = " max-w-2/5 md:max-w-1/2 lg:max-w-2/3 4xl:w-3/4 "
            break;
        }
        case 2: {
            gridCols = "grid-cols-2";
            maxW =" w-full 3xl:max-w-9/10 "
            break;
        }
        case 3: {
            gridCols = " grid-cols-3 ";
            break;
        }
    }

    instructionElement = (
        <div className={"grid " + gridCols + " justify-center items-center pb-2 " + maxW}>
            {elements}
        </div>);

    return (
        <div className="h-fit w-fit">
            <div className="h-5/6 justify-center my-auto">
                <div className="w-full h-5/6 flex justify-center mb-auto">
                    {instructionElement}
                </div>
                <div className="h-1/6">
                    <Header goForward={true} setClear={setPostAs} commitAnswer={commitAnswer} type={"videoInstruction"} />
                </div>
            </div>
        </div>);
}

export default StudentVideoInstructionItem;